import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  liveQuestionsData: [],
  totalliveQuestions: 0,
  isOpenModal: false,
}

export const liveQuestionsSlice = createSlice({
  name: "liveQuestions",
  initialState,
  reducers: {
    setliveQuestionsData(state, { payload }) {
      
      state.liveQuestionsData = payload.result
      state.totalliveQuestions = payload.count
    },
    updateliveQuestionsData(state, { payload }) {     
      const objIndex = state.liveQuestionsData.findIndex((obj) => obj._id === payload.result._id);      
      if (objIndex >= 0) {
        state.liveQuestionsData[objIndex] = payload.result
      }
    },
    deleteliveQuestionsData(state, { payload }) {
      const objIndex = state.liveQuestionsData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.liveQuestionsData.splice(objIndex, 1)
      }
    },
    pushliveQuestionsData(state, { payload }) {
      state.liveQuestionsData.push(payload.result)
      state.totalliveQuestions += 1
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setliveQuestionsData, updateliveQuestionsData, deleteliveQuestionsData, pushliveQuestionsData, isOpenModal,
  ModalToggle } = liveQuestionsSlice.actions;

export default liveQuestionsSlice.reducer;

export function getliveQuestions(limit, offset, id) {
  return async function getliveQuestionsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getliveQuestions(limit, offset, id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setliveQuestionsData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addliveQuestions(payload) {
  return async function addliveQuestionsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addliveQuestions(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushliveQuestionsData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateliveQuestions(id, data) {
  return async function updateliveQuestionsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateliveQuestions(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateliveQuestionsData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}


export function deleteliveQuestions(id) {
  return async function deleteliveQuestionsThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteliveQuestions(id).then(
        (response) => {
          dispatch(deleteliveQuestionsData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



